// import terrain from '../../assets/terrain_immo.mp4'
// import agro from '../../assets/agro.mp4'
// import social from '../../assets/social.mp4'
// import labelisation from '../../assets/labelisation.png'
// import etudeprojet from '../../assets/aisad.png'
// import learning from '../../assets/learning.jpg'

import friend1 from "../../assets/avatar7.jpg"
import friend2 from "../../assets/avatar1.jpg"
// import friend3 from "../../assets/avatar5.jpg"
// import friend4 from "../../assets/avatar6.jpg"
import user1 from "../../assets/avatar4.jpg"
// import user2 from "../../assets/avatar7.jpg"

const data = [
  {
    id: 1,
    projetCat:"Plastering",
    blockquote: "My hood ceiling looked like a trash, with great skill you made my living room a paradise",
    avatar: friend2,
    name: 'Waley Macha',
    rating: '7.9',
    date: '2021, 07, 30'
  },
  
  // {
  //   id: 3,
  //   projetCat:"Bathroom",
  //   blockquote:"from humid and not well isolated bathroom, with your great job, taking a bath it's real pleasure",
  //   avatar: friend4,
  //   name: 'Sati diengbeunou',
  //   rating: '8.5',
  //   date: '2024, 3, 3'
  // },
  {
    id: 3,
    projetCat:"door steps",
    blockquote:"I realy appreciated your effort for helping make my door steps stable",
    avatar: user1,
    name: 'Dion Sati',
    rating: '6.8',
    date: '2023, 05, 25'
  },

  {
    id: 4,
    projetCat:"Painting",
    blockquote:"The contractor skills blowed my mind. Thank you CARTILTD for this great job",
    avatar: friend1,
    name: 'Makowy Adaley',
    rating: '8.7',
    date: '2022, 07, 13'
  },
]

export default data



